module.exports = __webpack_public_path__ + "media/images/weather/343_night-ccfbea429b65ce59c8eca4356a465fcc.png";